import { render, staticRenderFns } from "./formLaporanTahunan.vue?vue&type=template&id=2004f411&scoped=true&"
import script from "./formLaporanTahunan.vue?vue&type=script&lang=js&"
export * from "./formLaporanTahunan.vue?vue&type=script&lang=js&"
import style0 from "./formLaporanTahunan.vue?vue&type=style&index=0&id=2004f411&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2004f411",
  null
  
)

export default component.exports